import { useMemo } from 'react';
import { ApiProductStatus } from '@ibk/shared-types';
import { formatDate } from './dateUtils';
export function createDateInfo(locale = 'pt-BR') {
    const rawDateInfo = formatDate(new Date(), { locale });
    return {
        formatted: `${rawDateInfo.dayOfWeek}, ${rawDateInfo.day} de ${rawDateInfo.month} de ${rawDateInfo.year}`,
        weekday: rawDateInfo.dayOfWeek,
        day: rawDateInfo.day,
        month: rawDateInfo.month,
        year: rawDateInfo.year,
    };
}
export function useFilteredCarouselItems(items, homeProducts) {
    return useMemo(() => {
        return items.filter(item => {
            if (!item.productAlias) {
                return true;
            }
            const product = homeProducts.products[item.productAlias];
            if (product?.error) {
                return true;
            }
            return !product.isLoading && product?.data?.status !== ApiProductStatus.ACTIVE;
        });
    }, [items, homeProducts]);
}
